import type { IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createCountFormxSubmissionsByProjectUseCase({ formxRepository }: Deps) {
  return async function countFormxSubmissionsByProject(projectId: string): Promise<number> {
    return formxRepository.countSubmissionsByProject(projectId);
  };
}
